<template>
  <div class="d-flex" :class="{ 'my-4': !dense }">
    <v-spacer />
    <v-btn
      v-if="!hideCancel"
      :id="`${prefix}-cancel-btn`"
      :disabled="loading"
      @click="$emit('cancel')"
    >
      {{ cancelText }}
    </v-btn>
    <v-btn
      v-if="!permission || ($root.user && $root.user.permissions.includes(permission))"
      :id="`${prefix}-submit-btn`"
      :loading="loading"
      :disabled="!valid"
      class="primary ml-2"
      @click="$emit('submit')"
    >
      {{ submitText }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    permission: String,
    valid: Boolean,
    loading: Boolean,
    prefix: {
      type: String,
      default: 'form-btns',
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    submitText: {
      type: String,
      default: 'Submit',
    },
  },
};
</script>
